import * as React from "react";
import type {Pointer} from "../../utils/interaction/Pointer";
import type {IPointerDetectorConfig} from "../../utils/interaction/PointerDetector";
import {PointerDetector} from "../../utils/interaction/PointerDetector";

interface IPointerDetectorProps extends Partial<IPointerDetectorConfig> {
	readonly onDown?: (pointer: Pointer) => void;
	readonly onMove?: (pointer: Pointer) => void;
	readonly onHoverMove?: (pointer: Pointer) => void;
	readonly onUp?: (pointer: Pointer) => void;
	readonly refObject: React.RefObject<HTMLElement | SVGElement>;
}

export class PointerDetectorReact extends React.Component<IPointerDetectorProps> {
	private _pointerDetector: PointerDetector;

	private removeEventListeners() {
		//if (!this._pointerDetector) return;

		this._pointerDetector.signals.down.removeAll();
		this._pointerDetector.signals.move.removeAll();
		this._pointerDetector.signals.hoverMove.removeAll();
		this._pointerDetector.signals.up.removeAll();
	}

	private addEventListeners(props: IPointerDetectorProps) {
		props.onDown && this._pointerDetector.signals.down.add(props.onDown);
		props.onMove && this._pointerDetector.signals.move.add(props.onMove);
		props.onHoverMove && this._pointerDetector.signals.hoverMove.add(props.onHoverMove);
		props.onUp && this._pointerDetector.signals.up.add(props.onUp);
	}

	private updateConfig(param: string) {
		const currentParam = this._pointerDetector.config[param as "element" | "parent"];

		if (this.props[param as "element" | "parent"] != null) {
			if (this.props[param as "element" | "parent"] !== currentParam) {
				this._pointerDetector.disable();
				this._pointerDetector.config[param as "element" | "parent"] = this.props[param as "element" | "parent"];
				this._pointerDetector.enable();
			}
		}
	}

	private initPointerDetector(props: Readonly<IPointerDetectorProps>) {
		this._pointerDetector = new PointerDetector({
			...props,
			element: props.element || props.refObject.current,
			parent: props.parent !== undefined ? props.parent : (props.refObject.current?.parentNode as HTMLElement),
		});
		this.addEventListeners(props);
	}

	public override componentDidMount() {
		this.initPointerDetector(this.props);
	}

	public override UNSAFE_componentWillReceiveProps(nextProps: Readonly<IPointerDetectorProps>, nextContext: any): void {
		if (this.props.refObject !== nextProps.refObject) {
			if (this._pointerDetector) {
				this.removeEventListeners();
				this._pointerDetector.dispose();
			}
			this.initPointerDetector(nextProps);
		}

		if (!this._pointerDetector) {
			// Not initialized yet – nothing to update
			return;
		}

		if (
			nextProps.onDown !== this.props.onDown ||
			nextProps.onMove !== this.props.onMove ||
			nextProps.onHoverMove !== this.props.onHoverMove ||
			nextProps.onUp !== this.props.onUp
		) {
			this.removeEventListeners();
			this.addEventListeners(nextProps);
		}
	}

	public override componentDidUpdate() {
		if (this._pointerDetector) {
			this.updateConfig("element");
			this.updateConfig("parent");
		}
	}

	public override componentWillUnmount() {
		if (this._pointerDetector) {
			this._pointerDetector.dispose();
			this._pointerDetector = null;
		}
	}

	public override render() {
		return <></>;
	}
}
